<template>
  <Gift @close="close"></Gift>
</template>
<script>
import Gift from '@/components/update/Gift.vue'
import { registReturnGameFunction } from '@/bridge/AppJsBridge';

export default {
  methods: {
    close() {
      registReturnGameFunction(null);
    }
  },
  components: {
    Gift
  }
}
</script>